const getters = {
  userInfo: state => state.user.userInfo,
  tagList: state => state.user.tagList,
  categoryList: state => state.search.categoryList,
  classNamesList: state => state.search.classNamesList
}

export default getters
